import { useState } from "react";
import { api } from "../../App";
import { Button } from "./button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./dropdown-menu";
import { Download, FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ExportDropdown({ 
  endpoint, 
  filename, 
  queryParams = {},
  disabled = false 
}) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async (format) => {
    setExporting(true);
    try {
      const queryString = new URLSearchParams(queryParams).toString();
      const url = `${endpoint}/${format}${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url, {
        responseType: 'blob'
      });
      
      // Create download link
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      
      const extension = format === 'excel' ? 'xlsx' : 'pdf';
      link.download = `${filename}_${new Date().toISOString().split('T')[0]}.${extension}`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
      toast.success(`${format.toUpperCase()} exported successfully!`);
    } catch (error) {
      console.error('Export error:', error);
      toast.error(`Failed to export ${format.toUpperCase()}`);
    } finally {
      setExporting(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          className="border-slate-600 text-slate-300 hover:bg-slate-800"
          disabled={disabled || exporting}
          data-testid="export-dropdown-btn"
        >
          {exporting ? (
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          ) : (
            <Download className="w-4 h-4 mr-2" />
          )}
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-[#151A23] border-slate-700">
        <DropdownMenuItem 
          onClick={() => handleExport('excel')}
          className="text-slate-300 hover:bg-slate-800 cursor-pointer"
          data-testid="export-excel-btn"
        >
          <FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-400" />
          Export to Excel
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleExport('pdf')}
          className="text-slate-300 hover:bg-slate-800 cursor-pointer"
          data-testid="export-pdf-btn"
        >
          <FileText className="w-4 h-4 mr-2 text-red-400" />
          Export to PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
